// extracted by mini-css-extract-plugin
module.exports = {"userText":"bs-lp20-src-components-intl-string-html-module-user-text"};